<template>
  <AuthModal v-if="isOpen" />
</template>
<script setup lang="ts">
const auth = useAuthStore()
const user = useUserStore()
const tracking = useTracking()
const route = useRoute()
const router = useRouter()
const wishlist = useWishlistStore()
const { add: addToWishlist } = useWishlist()
const [isOpen, toggle] = useToggle()
const { buildWishlistUrl } = useURLs()

const authModalEvt = useEventBus<AuthState>('authModal')

const queryCleaned: Ref<boolean> = ref(false)

onMounted(async () => {
  authModalEvt.on(handleAuthModalState)
  await checkIfUserDeleted()
})

onUnmounted(async () => {
  authModalEvt.off(handleAuthModalState)
})

async function handleAuthModalState(state: AuthState) {
  toggle(state.status)
  if (!state.status && auth.isAuthorized) {
    await auth.init(true)
    await user.load()

    if (auth.state?.target === 'wishlists') {
      await navigateTo(buildWishlistUrl().toString(), { external: true })
    }

    if (auth.state?.accomCode) {
      tracking.handlers?.wishlists.addPropertyRedirectSuccess(
        auth.state?.accomCode,
      )
      wishlist.selectAccommodationToAdd(auth.state?.accomCode)
      addToWishlist({ code: auth.state?.accomCode })
    }
    resetAuthState()
  }

  if (!state.status) {
    resetAuthState()
  }
}

function resetAuthState() {
  auth.setState({ status: false, accomCode: '', target: undefined })
}

async function checkIfUserDeleted() {
  if (
    import.meta.client &&
    route.query &&
    route.query['isDeleted'] &&
    !queryCleaned.value
  ) {
    const { isDeleted, ...cleanQuery } = route.query
    queryCleaned.value = true
    await router.replace({ path: route.path, query: cleanQuery })
  }
}
</script>
